const SuperAdmin = () => {
    return (
        <>





        </>
    );
}

export default SuperAdmin;